/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { take } from 'rxjs/operators';
import { L10nService } from '@vmw/ngx-vip';
import { VsAppProfileType } from '../../../logs.types';

import * as l10n from './traffic-logs-type-dropdown.l10n';
import './traffic-logs-type-dropdown.component.less';
import { ITrafficLogsStates, TrafficLogsStore } from '../traffic-logs.store';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Dropdown used to pick App Profile Type for VS's that can have both L4 and L7.
 * @author Yogesh Patil
 */
@Component({
    selector: 'traffic-logs-type-dropdown',
    templateUrl: './traffic-logs-type-dropdown.component.html',
})
export class TrafficLogsTypeDropdownComponent {
    public readonly l10nKeys = l10nKeys;

    public vsAppProfileTypeEnum = VsAppProfileType;

    /**
     * Currently selected log type.
     */
    public selectedLogType: VsAppProfileType;

    constructor(
        l10nService: L10nService,
        protected readonly trafficLogsStore: TrafficLogsStore<ITrafficLogsStates>,
    ) {
        l10nService.registerSourceBundles(dictionary);

        trafficLogsStore.vsAppProfileType$.pipe(take(1)).subscribe(type => this.selectedLogType = type);
    }

    /**
     * Update the selected log type in the store.
     */
    public setLogType(type: VsAppProfileType): void {
        this.trafficLogsStore.setVsAppProfileType(type);
    }
}
